import React from "react"
import styled from "styled-components"

import config from "../../Config"
import { secondsToHms } from "../../util/Utility"
const BidBox = styled.div`
  width: 100%;
  height: 128px;
  margin: 18px 0px;
  padding: 25px 15px;
  border-radius: 8px;
  background-color: #383d5a;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
`
const LeftBox = styled.div``

const RightBox = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  margin-left: 20px;
`

const ImgWrapper = styled.div`
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
`

const Title = styled.p`
  width: 100%;
  text-align: left;
  font-family: "montserratLight";
  color: #fff;
  font-size: 14px;
  margin: 0;
`
const BidText = styled.span`
  font-family: "montserratRegular";
  color: #ffcf86;
  font-size: 16px;
  text-align: left;
`
const Text = styled.span`
  font-family: "montserratLight";
  color: #fff;
  font-size: 16px;
`
const Timer = styled.p`
  width: 100%;
  text-align: left;
  margin: 0;
  font-family: "montserratRegular";
  font-size: 16px;
  color: #fff;
`

const MyBidBox = (
  {
    offerImageUrl,
    offerTitle,
    bidCount,
    offerTimeLeft,
    onClick,
    expiredBid,
    winner,
  },
  props
) => {
  console.log("props", expiredBid)
  return (
    <BidBox onClick={onClick}>
      <LeftBox>
        <ImgWrapper>
          <img src={offerImageUrl} style={{ width: "100%", height: "74px" }} />
        </ImgWrapper>
      </LeftBox>
      <RightBox>
        <Title>{offerTitle}</Title>
        {expiredBid && winner && (
          <BidText
            style={{
              color: "#fb0e56",
              fontWeight: "bold",
              marginTop: "5px",
              fontSize: "17px",
            }}
          >
            You are a Winner
          </BidText>
        )}
        <div style={{ margin: "8px 0" }}>
          <BidText>
            {bidCount <= 1 ? bidCount + " Bid" : bidCount + " Bids"}
          </BidText>
          &nbsp;
          <Text>placed</Text>
        </div>
        {expiredBid !== "true" && <Timer>{secondsToHms(offerTimeLeft)}</Timer>}
      </RightBox>
    </BidBox>
  )
}

export default MyBidBox



// WEBPACK FOOTER //
// ./src/components/bidTab/MyBidBox.js